import R from "ramda";

export const stateForOrderBy = (state, key) => {
  if (key === state.orderBy) {
    const newDirection = state.orderDirection === "DESC" ? "ASC" : "DESC";
    return R.set(R.lensProp("orderDirection"), newDirection, state);
  }

  return R.merge(state, { orderBy: key, orderDirection: "ASC" });
};

export const addToSelectedVendors = (state, name) => {
  const { selectedVendors } = state;
  if (R.contains(name, selectedVendors)) {
    return state;
  }
  return R.merge(state, { selectedVendors: R.append(name, selectedVendors) });
};

export const addToSelectedPaymentTypes = (state, key) => {
  const { selectedPaymentTypes } = state;
  if (key === "none") {
    return R.merge(state, { selectedPaymentTypes: ["none"] });
  }

  if (R.contains(name, selectedPaymentTypes)) {
    return state;
  }
  const newSelectedPaymentTypes = R.append(key, selectedPaymentTypes).filter(type => type !== "none");
  return R.merge(state, { selectedPaymentTypes: newSelectedPaymentTypes });
};

export const addToSelectedCategories = (state, name) => {
  const { selectedCategories } = state;
  if (R.contains(name, selectedCategories)) {
    return state;
  }
  return R.merge(state, { selectedCategories: R.append(name, selectedCategories) });
};

export const addToSelectedCurrencies = (state, key) => {
  const { selectedCurrencies } = state;
  if (R.contains(name, selectedCurrencies)) {
    return state;
  }
  return R.merge(state, { selectedCurrencies: R.append(key, selectedCurrencies) });
};

export const removeSelectedVendor = (state, name) => {
  const { selectedVendors } = state;
  const newSelectedVendors = selectedVendors.filter(vendor => vendor !== name);
  return R.merge(state, { selectedVendors: newSelectedVendors });
};

export const removeSelectedPaymentType = (state, key) => {
  if (key === "none") {
    return R.merge(state, { selectedPaymentTypes: [] });
  }
  const { selectedPaymentTypes } = state;
  const newSelectedPaymentTypes = selectedPaymentTypes.filter(type => type !== key);
  return R.merge(state, { selectedPaymentTypes: newSelectedPaymentTypes });
};

export const removeSelectedCategory = (state, name) => {
  const { selectedCategories } = state;
  const newSelectedCategories = selectedCategories.filter(category => category !== name);
  return R.merge(state, { selectedCategories: newSelectedCategories });
};

export const addToSelectedEnvelopes = (state, code) => {
  const { selectedEnvelopes } = state;
  if (R.contains(code, selectedEnvelopes)) {
    return state;
  }
  return R.merge(state, { selectedEnvelopes: R.append(code, selectedEnvelopes) });
};

export const removeSelectedEnvelope = (state, code) => {
  const { selectedEnvelopes } = state;
  const newSelectedEnvelopes = selectedEnvelopes.filter(envelope => envelope !== code);
  return R.merge(state, { selectedEnvelopes: newSelectedEnvelopes });
};

export const removeSelectedCurrency = (state, key) => {
  const { selectedCurrencies } = state;
  const newSelectedCurrencies = selectedCurrencies.filter(currency => currency !== key);
  return R.merge(state, { selectedCurrencies: newSelectedCurrencies });
};

export const addToSelectedCardNumbers = (state, key) => {
  const { selectedCardNumbers } = state;
  if (R.contains(key, selectedCardNumbers)) {
    return state;
  }
  return R.merge(state, { selectedCardNumbers: R.append(key, selectedCardNumbers) });
};

export const removeSelectedCardNumber = (state, key) => {
  const { selectedCardNumbers } = state;
  const newSelectedCardNumbers = selectedCardNumbers.filter(card => card !== key);
  return R.merge(state, { selectedCardNumbers: newSelectedCardNumbers });
};

export const stateForAddSearchQueryToFilter = (state, query) => {
  if (query === "") {
    return R.merge(state, { selectedSearchQueryString: null });
  }
  return R.merge(state, {
    searchQueryString: "",
    selectedSearchQueryString: query
  });
};



// WEBPACK FOOTER //
// ./src/js/reducers/functions/documents-exports-filters-functions.js